import React from 'react';
import './Layout.module.scss';
/**
 * Layout template
 */
const Layout = ({
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, children);
export default Layout;